// extracted by mini-css-extract-plugin
module.exports = {"dateHeader":"UploadedListPage_dateHeader__TutQ0"};